import { render, staticRenderFns } from "./DiyBD.vue?vue&type=template&id=f7070186&scoped=true&"
import script from "./DiyBD.vue?vue&type=script&lang=js&"
export * from "./DiyBD.vue?vue&type=script&lang=js&"
import style0 from "./DiyBD.vue?vue&type=style&index=0&id=f7070186&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7070186",
  null
  
)

export default component.exports